import { ControlProps, CSSObjectWithLabel, GroupBase, Props, StylesConfig } from 'react-select';

// Prop type to allow extending react-select's props
export interface IGroupSelectOption {
    label: string;
    options: ISelectOption[];
}

export interface ISelectOption {
    label: string;
    value: string;
}

export type SelectProps<Option, IsMulti extends boolean, Group extends GroupBase<Option> = GroupBase<Option>> = Props<
    Option,
    IsMulti,
    Group
>;

export type DefaultSelectProps = SelectProps<ISelectOption, boolean>;

export const UskinnedSelectStyles: StylesConfig = {
    control: (provided: CSSObjectWithLabel, state: ControlProps) => {
        const defaultBorderColor = 'rgba(var(--base-borders),1)';
        return {
            ...provided,
            boxShadow: 'none',
            borderColor: defaultBorderColor,
            outline: state.isFocused || state.menuIsOpen ? 'rgba(var(--base-highlight),1) auto 2px' : 'transparent',
            outlineOffset: '2px',
            ':hover': {
                borderColor: defaultBorderColor
            }
        };
    }
};
